import PopUp from '../../../../Shared/Popup/PopUp';
import React, {useEffect, useState} from 'react';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {stageEnums} from '../../Assets/VolteCheckVariables';
import TickDynamica from '../../Assets/SVG/TickDynamica';
import {isMobile} from 'react-device-detect';

const CallBackScreen = (props) => {
  const [fullName, setName] = useState('');
  const [nameError, setNameError] = useState(null);
  const [phoneNumber, setPhone] = useState('');
  const [PhoneError, setPhoneError] = useState(null);

  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע המעודכן והאמין <br />
      ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת <br />
      לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );
  const btnText = props.data.sentCallback ? (
    <>
      <TickDynamica />
      <p style={{margin: '0px'}}>נציגינו יחזרו אליכם בהקדם!</p>
    </>
  ) : (
    <>שליחה</>
  );

  return (
    <>
      <PopUp
        showPopUp={true}
        onClose={() => {
          props.setStage(stageEnums.notSupported);
        }}>
        <div className='headBox'>
          <p className='heading'>מתלבטים איזה מכשיר לבחור? </p>
          <p className='subHeading'>השאירו פרטים ונחזור אליכם בהקדם</p>
        </div>
        <div>
          <TextInput
            placeholder={'שם מלא'}
            value={fullName}
            type='text'
            error={nameError}
            onChange={(e) => {
              e.persist();
              setName(e.target.value);
            }}
          />
        </div>
        <div style={{marginBottom: '12px'}}>
          <TextInput
            placeholder={'מספר טלפון'}
            value={phoneNumber}
            maxLength='10'
            type='numeric'
            error={PhoneError}
            onChange={(e) => {
              const numberRegex = /^\d+$/;
              if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 10) {
                setPhone(e.target.value);
              }
            }}
          />
        </div>
        <BtnSubmit
          onclick={() => {
            if (!props.data.sentCallback) {
              const nameErrorSetter = fullName == '' ? 'אנא הזן את שמך המלא' : null;
              const phoneErrorSetter = phoneNumber.length < 10 ? 'המספר שהוזן שגוי' : null;
              setNameError(nameErrorSetter);
              setPhoneError(phoneErrorSetter);
              if (nameErrorSetter == null && phoneErrorSetter == null) {
                props.openWorkOrder({fullName: fullName, contactNumber: phoneNumber, isDynamica: true});
              }
            }
          }}
          className={`submitBtn ${props.data.sentCallback ? 'unclickable' : ''} callBackSubmit`}
          text={btnText}
        />
        <div className='headBox' style={{marginTop: '24px'}}>
          <p className='subHeading' style={{marginBottom: '0px', fontSize: '14px'}}>
            הנתונים שימסרו על ידך ישמרו במאגרי המידע של חברת דינמיקה <br />
            בע"מ, שתעשה בהם שימוש בהתאם{' '}
            <a
              href='#'
              className='privacyPolicyLink'
              onClick={() => {
                buildUrlAndOpenSameWindow(props.iContent.privacyPolicyUrl.value);
              }}>
              למדיניות הפרטיות של <br />
              החברה
            </a>{' '}
          </p>
        </div>
        {disclaimerText}
      </PopUp>
    </>
  );
};

export default CallBackScreen;
